import React from "react";
import styled from "styled-components";

const FormInputError = ({ children, show, ...props }) => {
  if (children && show) {
    return (
      <Error {...props}>
        {children}
      </Error>
    );
  }

  return null;
};

const Error = styled.div`
  width: 300px;
  min-height: 16px;
  color: red;
  font-size: 12px;
  margin-top: 3px;
`;

export default FormInputError;